




























































import Vue from 'vue';
import type { PropOptions } from 'vue';
import { email, minLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';

export default Vue.extend({
  name: 'SignUpForm',
  components: {
    BravadoTheme,
    BravadoButtonV3,
    BravadoTextInputV3,
  },
  mixins: [validationMixin],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    } as PropOptions<Boolean>,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        firstname: '',
        lastname: '',
      },
      attemptedSubmission: false,
      isValid: true,
    };
  },
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(6) },
      firstname: { required },
      lastname: { required },
    },
  },
  computed: {
    passwordErrorMessage(): string {
      if (this.isFieldValid('password')) return '';
      if (!this.$v.form.password?.required) return 'Password is required';
      if (!this.$v.form.password.minLength) return 'Password must be at least 6 characters long';

      return '';
    },
    emailErrorMessage(): string {
      if (this.isFieldValid('email')) return '';
      if (!this.$v.form.email?.required) return 'Email is required';
      if (!this.$v.form.email.email) return 'Please provide a valid email';

      return '';
    },
    lastnameErrorMessage(): string {
      return this.isFieldValid('firstname') ? '' : 'Last name is required';
    },
    firstnameErrorMessage(): string {
      return this.isFieldValid('lastname') ? '' : 'First name is required';
    },
  },
  methods: {
    isFieldValid(fieldName: string) {
      const formElement = this.$v.form[fieldName]!;
      return !(this.attemptedSubmission && formElement.$invalid) && this.isValid;
    },
    signUp() {
      this.$v.form.$invalid ? (this.attemptedSubmission = true) : this.$emit('signUp', this.form);
    },
  },
});
